import React from "react";
import { Colors } from "../../Constants/colors";

interface Props {
  headerText: string;
  subText?: string;
}

export const SectionHeader = ({ headerText, subText = "" }: Props) => {
  return (
    <>
      <div className="Header ont-medium text-lg mt-2">{headerText}</div>
      {subText ? (
        <div
          className="font-sm text-sm mt-2"
          style={{ color: Colors.Grey, maxWidth: "32rem" }}
        >
          {subText}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
